<app-full-screen-slider [active]="activeFullScreen"
                        [photo]="activePhoto"
                        [count]="activePhotos.length"
                        (activeEmit)="activeFullScreen = $event"
                        (clickLeftEmit)="nextPhoto()"
                        (clickRightEmit)="prevPhoto()"
/>
<div class="slider-horizontal-container" #container>
    <div class="slider-container" #movableElement
         [style]="isMobile ? 'overflow: hidden' : ''"
         (mousedown)="startDrag($event)" (mouseup)="endDrag($event)" (mouseleave)="endDrag($event)"
         (touchstart)="startDrag($event)" (touchend)="endDrag($event)" (touchmove)="onTouchMove($event)"
         (wheel)="onWheel($event)" (scroll)="onScroll($event)" (dblclick)="handleDoubleClick($event)"
    >
        <div *ngFor="let el of formattedElements; index as i" class="slider" [class]="el" [style]="setSliderStyles()">
            <p *ngIf="test">{{ i }}</p>
            <app-slider-item
                    (click)="clickMobile()"
                    *ngIf="!test"
                    [article]="el"
                    (scrolling)="changeScrolling($event)"
                    [backgroundContain]="false"
                    [isMobile]="isMobile"
            />
        </div>
    </div>
</div>
